import React from "react";
import {getQueryParam} from "~/utils";

export default function useQueryParam(history, param, defaultValue = null) {
  const [currentValue, setCurrentValue] = React.useState(getQueryParam(history, param));

  React.useEffect(() => {
    return history.listen(() => {
      const value = getQueryParam(history, param);

      if (value !== currentValue) {
        setCurrentValue(value);
      }
    })
  }, [history, param, currentValue, setCurrentValue]);

  return currentValue || defaultValue;
}
